module.exports = __webpack_public_path__ + "message.png?9f7bad560b6e9aa0e1bcc9e9eff70897";


//////////////////
// WEBPACK FOOTER
// ./src/assets/message.png
// module id = 86
// module chunks = 0